export enum CTA_TYPE {
  VIDEO = 'video',
  LINK = 'link'
}
